import * as XLSX from "xlsx";

export const excelToJson = (file, onSuccess, onError, options = {}) => {
  // Default options
  const { skipFirstRow = true, filterFunction = null, mapFunction = null } = options;

  // Validate if file exists
  if (!file) {
    onError("No file provided");
    return;
  }

  // Validate file type
  if (
    file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
    file.type !== "application/vnd.ms-excel"
  ) {
    onError("Invalid file type. Please upload an Excel file.");
    return;
  }

  // Validate file size
  if (file.size > 5 * 1024 * 1024) {
    // 5 MB limit
    onError("File size exceeds the limit of 5 MB.");
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = e.target.result;
      const readData = XLSX.read(data, { type: "binary" });
      const sheetName = readData.SheetNames[0];
      const worksheet = readData.Sheets[sheetName];

      //Convert array to JSON
      const dataParse = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Validate if data is empty
      if (dataParse.length === 0) {
        onError("The Excel file is empty.");
        return;
      }

      // Skip first row if specified
      if (skipFirstRow) {
        dataParse.splice(0, 1); // Remove the first row
      }

      // Convert to JSON
      const processedData = [];

      dataParse.forEach((row, rowIndex) => {
        // Apply filter function if provided
        if (filterFunction && !filterFunction(row, rowIndex)) {
          return; // Skip this row
        }

        // Skip empty rows
        if (row.length === 0) {
          return;
        }

        let processedRow;
        if (mapFunction) {
          // Use custom mapping function
          processedRow = mapFunction(row, rowIndex);
        } else {
          // Default: convert to generic object with column indices as keys
          processedRow = {};
          row.forEach((cell, cellIndex) => {
            processedRow[`col_${cellIndex}`] = cell === undefined ? null : cell;
          });
        }

        if (processedRow) {
          // Convert field value to text
         const textConvertedRow = {};
          // Convert field value to text
          Object.keys(processedRow).forEach((key) => {
            const value = processedRow[key];
            // Convert to text, handle null/undefined values
            if (value === null || value === undefined) {
              textConvertedRow[key] = null;
            } else {
              textConvertedRow[key] = String(value).trim();
            }
          });

          processedData.push(textConvertedRow);
        }
      });

      console.log("Processed Excel data:", processedData);
      onSuccess(processedData);
    } catch (err) {
      console.error("Excel parsing error:", err);
      onError("Error reading Excel file.");
    }
  };

  reader.onerror = () => {
    onError("Failed to read the file");
  };

  reader.readAsBinaryString(file);
};
